module.exports = __webpack_public_path__ + "static/media/overta.67175dc2.mp3";